import { ConfigureResource } from "@/api/generated-api";
import { FormFieldType } from "@/components/ui/form-field/types";
import z from "zod";

export const REQUEST_FORM_SCHEMA = z.object({
  email: z.string().trim().min(1, "Укажите e-mail").email("Введите корректный e-mail"),
  phone: z.string().trim().optional().default(""),
  name: z.string().trim().min(1, "Укажите имя"),
  message: z.string().trim().min(1, "Укажите сообщение"),
  files: z
    .array(z.custom<File>(value => typeof File !== "undefined" && value instanceof File, "Некорректный файл"))
    .optional()
    .default([]),
});

export const REQUEST_FORM_FIELDS: Array<FormFieldType & { id: keyof ConfigureResource }> = [
  {
    id: "name",
    label: "Ваше имя *",
    type: "text",
    required: true,
    autoComplete: "name",
  },
  {
    id: "email",
    label: "E-mail *",
    type: "email",
    required: true,
    autoComplete: "email",
  },
  {
    id: "phone",
    label: "Телефон",
    type: "tel",
    defaultValue: "+7",
    autoComplete: "tel",
  },
  {
    id: "message",
    label: "Сообщение *",
    type: "text",
    required: true,
    multiline: true,
    placeholder: "Опишите ваше видение...",
  },
];
